export default __webpack_public_path__ + "static/giants-0fe69046c1bed44d62c499cb9f018a31.png";